<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-alert type="error" border="left" prominent outlined>
					<h3>Forbidden</h3>
					<p>
						You are not authorized to access this resource. If this is an error
						please contact your system administrator to verify your permissions.
					</p>
				</v-alert>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col cols="12" class="text-center">
				<v-btn color="primary" large @click="goHome">Go Home</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	methods: {
		goHome() {
			this.$router.replace({ name: "Home" });
		},
	},
};
</script>
